import type { QueryClient } from '@tanstack/react-query';

let channel: BroadcastChannel | null = null;

function getChannel() {
  if (!channel && typeof BroadcastChannel !== 'undefined') {
    channel = new BroadcastChannel('mesa-auth');
  }
  return channel;
}

export function broadcastAuthChange() {
  getChannel()?.postMessage({ type: 'auth-change' });
}

export function onAuthChange(queryClient: QueryClient) {
  const ch = getChannel();
  if (!ch) return;
  ch.onmessage = () => {
    queryClient.invalidateQueries({ queryKey: ['auth-session'] });
    queryClient.invalidateQueries({ queryKey: ['auth-orgs'] });
  };
}
